import FAQ from '@/components/FAQ/FAQ';
import { useAppContext } from '@/contexts/AppContext';
import { useState } from 'react';

const FAQsSection = () => {
  const { community } = useAppContext();
  const [openIndex, setOpenIndex] = useState<number>();

  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600">Everything you need to know about our community</p>
        </div>

        <div className="space-y-4">
          {(community?.faqs ?? []).map((faq, index) => (
            <FAQ
              faq={faq}
              key={`faq-${index}`}
              open={openIndex === index}
              onOpen={() => setOpenIndex(index)}
              onClose={() => setOpenIndex(undefined)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQsSection;
